// extracted by mini-css-extract-plugin
module.exports = {"locationCard":"styles_locationCard__fFLQ1","btnsContainer":"styles_btnsContainer__3peKS"};